import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Header, Titulo} from '../elementos/Header'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioTipoPublicacion from './FormularioTipoPublicacion'
import favicon from '../imagenes/logoutm.png'

const RegistroCultura = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Registro de Tipo de Publicaciones</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Registro de Tipo de Publicaciones</Titulo>
                    <BtnRegresar ruta="/tipo-publicaciones"/>
            </Header>

            <FormularioTipoPublicacion />
        </>
    );
}
 
export default RegistroCultura;